module.exports = __webpack_public_path__ + "UMB Contribution and Mistaken Distribution Reversal Form.pdf";